import React, { useState, useEffect, memo, Fragment, useMemo } from "react";
import { Row, Col, Dropdown, Button } from "react-bootstrap";
// import { Link } from "react-router-dom";
// import axios from "axios";
import Card from '../../components/Card'

//circular
import Circularprogressbar from "../../components/circularprogressbar.js";

//Dashboar Service
import DashboardService from "../../services/pbumku/DashboardService";

// AOS
import AOS from "aos";
import "../../../node_modules/aos/dist/aos";
import "../../../node_modules/aos/dist/aos.css";
//apexcharts
import Chart from "react-apexcharts";

//swiper
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation } from "swiper";

// Import Swiper styles
import "swiper/swiper-bundle.min.css";
// import 'swiper/components/navigation/navigation.scss';

//progressbar
import Progress from "../../components/progress.js";
//img
import shapes1 from "../../assets/images/shapes/01.png";
import shapes2 from "../../assets/images/shapes/02.png";
import shapes3 from "../../assets/images/shapes/03.png";
import shapes4 from "../../assets/images/shapes/04.png";
import shapes5 from "../../assets/images/shapes/05.png";

//Count-up
import CountUp from "react-countup";

// Redux Selector / Action
import { useSelector } from "react-redux";

// Import selectors & action from setting store
import * as SettingSelector from "../../store/setting/selectors";
import { get } from "sortablejs";
import { set } from "date-fns";

// install Swiper modules
SwiperCore.use([Navigation]);

const Index = memo((props) => {
  const [permohonanCnt, setPermohonanCnt] = useState(0);
  const [sertifikatCnt, setSertifikatCnt] = useState(0);
  const [verifyCnt, setVerifyCnt] = useState(0);
  const [perizinans, setPerizinans] = useState([]);
  const [spt, setSpt] = useState(0);
  const [provinsi, setProvinsi] = useState([]);
  const [upi, setUpi] = useState(0);
  const [haccp, setHaccp] = useState(0);
  const [skv, setSkv] = useState(0);
  const [upn, setUpn] = useState(0);
  let DashService = useMemo(() => new DashboardService(), []);
  const [frequensi, setFrequensi] = useState([]); // data frequensi
  const [frequensiNegara, setFrequensiNegara] = useState([]);
  const [frequensiUpt, setFrequensiUpt] = useState([]); // data frequensi upt
  const [frequensiTrader, setFrequensiTrader] = useState([]);
  const [jumfreq, setJumfreq] = useState(0); // jumlah data frequensi
  const [jumVol, setJumVol] = useState(0); // jumlah data volume
  const [nilaiIDR, setNilaiIDR] = useState(0); // Nilai Rupiah
  const [nilaiUSD, setNilaiUSD] = useState(0); // Nilai USD 
  const [bulanTahun, setBulanTahun] = useState([]);
  const [namaUPT, setNamaUPT] = useState(null);
  const [isVisibleUpt, setIsVisibleUpt] = useState(false); // check yang login, dari upt atau dari pusat
  const [isNol, setIsNol] = useState(false); // data sudah ada atau belum
  const [isTrader, setIsTrader] = useState(false); // check yang login, dari trader atau bukan

  // Variabel untuk baca tanggal
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth(); // 0-11
  const [startOfMonth, setStartOfMonth] = useState(new Date(year, month, 1));
  const [endOfMonth, setEndOfMonth] = useState(new Date(year, month + 1, 0)); // 0 = last day of previous month

  // variable baca role
  const [role, setRole] = useState(localStorage.getItem("role"));

  // variabel baca upt
  const [kdUPT, setKdUPT] = useState(localStorage.getItem("kdUnit"));

  // Helper untuk format ke "yyyy/mm/dd"
  const formatDate = (date) => {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0'); // bulan dimulai dari 0
    const dd = String(date.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  };

  const [selectedBulan, setSelectedBulan] = useState(today.toLocaleString("id-ID", { month: "long" }) + " " + today.toLocaleString("default", { year: "numeric" }));

  useEffect(() => {
    getRole();
    getPermohonanCnt();
    getSertifikatCnt();
    getVerifyCnt();
    getPerizinansCnt();
    getSptCnt();
    getProvinsiCnt();
    getUpiCnt()
    getSftCnt()
    getSkvCnt()
    getUpnCnt()
    getFrequensi();
    getFrequensiNegara();
    getFrequensiUpt();
    getFrequensiTrader();
    getJumlahFrequensi();
    getJumlahVolume();
    getNilai();
    getBulanTahun();
    getNamaUPT();
  }, []);

  useEffect(() => {
    getFrequensi();
    getFrequensiNegara();
    getFrequensiUpt();
    getFrequensiTrader();
    getJumlahFrequensi();
    getJumlahVolume();
    getNilai();
    getBulanTahun();
    getNamaUPT();
  }, [startOfMonth, endOfMonth]);

  const getPermohonanCnt = async () => {
    try {
      const response = await DashService.getCount();
      setPermohonanCnt(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getSertifikatCnt = async () => {
    try {
      const response = await DashService.getSertifikat();
      setSertifikatCnt(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getVerifyCnt = async () => {
    try {
      const response = await DashService.getVerify();
      setVerifyCnt(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getPerizinansCnt = async () => {
    try {
      const response = await DashService.getSertifikasi();
      setPerizinans(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getSptCnt = async () => {
    try {
      const response = await DashService.getSpt();
      setSpt(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getProvinsiCnt = async () => {
    try {
      const response = await DashService.getProvinsi();
      setProvinsi(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getUpiCnt = async () => {
    try {
      const response = await DashService.getUpi();
      setUpi(response.data[0].nilai1);
    } catch (error) {
      console.log(error);
    }
  };

  const getSftCnt = async () => {
    try {
      const response = await DashService.getSft();
      setHaccp(response.data[0].nilai1);
    } catch (error) {
      console.log(error);
    }
  };

  const getSkvCnt = async () => {
    try {
      const response = await DashService.getSkv();
      setSkv(response.data[0].nilai1);
    } catch (error) {
      console.log(error);
    }
  };

  const getUpnCnt = async () => {
    try {
      const response = await DashService.getUpn();
      setUpn(response.data[0].nilai1);
    } catch (error) {
      console.log(error);
    }
  };

  const getFrequensi = async () => {
    const response = await DashService.getFrequensi(kdUPT, formatDate(startOfMonth), formatDate(endOfMonth))
    setFrequensi(response.data)
  };

  const getFrequensiNegara = async () => {
    const response = await DashService.getFrequensiNegara(kdUPT, formatDate(startOfMonth), formatDate(endOfMonth))
    setFrequensiNegara(response.data)
  };

  const getFrequensiUpt = async () => {
    const response = await DashService.getFrequensiUpt(kdUPT, formatDate(startOfMonth), formatDate(endOfMonth))
    setFrequensiUpt(response.data)
  };

  const getFrequensiTrader = async () => {
    const response = await DashService.getFrequensiTrader(kdUPT, formatDate(startOfMonth), formatDate(endOfMonth))
    setFrequensiTrader(response.data)
  };

  const getJumlahFrequensi = async () => {
    const response = await DashService.getJumlahFrequensi(kdUPT, formatDate(startOfMonth), formatDate(endOfMonth))
    setJumfreq(response.data)
    if (response.data === 0) {
      setIsNol(true)
    }
  };

  const getJumlahVolume = async () => {
    const response = await DashService.getJumlahVolume(kdUPT, formatDate(startOfMonth), formatDate(endOfMonth))
    setJumVol(response.data.totalVolume)
  };

  const getNilai = async () => {
    const response = await DashService.getJumlahNilai(kdUPT, formatDate(startOfMonth), formatDate(endOfMonth))
    setNilaiIDR(response.data.totalNilaiIDR)
    setNilaiUSD(response.data.totalNilaiUSD)
  };

  const getBulanTahun = async () => {
    const response = await DashService.getBulanTahun()
    setBulanTahun(response.data)
  };

  const getNamaUPT = async () => {
    const cleanedKdUPT = kdUPT.trim();
    const excludedUPTs = new Set(['00.1', '00.2', '00.3']);
    const isExcluded = excludedUPTs.has(cleanedKdUPT);

    if (!isExcluded) {
      const kdUnit = localStorage.getItem("kdUnit");
      try {
        const response = await DashService.getNamaUPT(cleanedKdUPT);
        setNamaUPT(response.data.NM_PENDEK);
        setIsVisibleUpt(true);
      } catch (error) {
        console.log(error);
      }
    }
  };

  const getRole = () => {
    const roleaturan = localStorage.getItem("role");
    const includedTrader = new Set(['4', '5']);
    const isIncluded = includedTrader.has(roleaturan);
    if (isIncluded) {
      console.log('ini trader');
      setIsTrader(true);
    } else {
      console.log('ini bukan trader');
      setIsTrader(false);
    }
  };

  useSelector(SettingSelector.theme_color);

  const getVariableColor = () => {
    let prefix =
      getComputedStyle(document.body).getPropertyValue("--prefix") || "bs-";
    if (prefix) {
      prefix = prefix.trim();
    }
    const color1 = getComputedStyle(document.body).getPropertyValue(
      `--${prefix}primary`
    );
    const color2 = getComputedStyle(document.body).getPropertyValue(
      `--${prefix}info`
    );
    const color3 = getComputedStyle(document.body).getPropertyValue(
      `--${prefix}primary-tint-20`
    );
    const color4 = getComputedStyle(document.body).getPropertyValue(
      `--${prefix}warning`
    );
    return {
      primary: color1.trim(),
      info: color2.trim(),
      warning: color4.trim(),
      primary_light: color3.trim(),
    };
  };
  const variableColors = getVariableColor();

  const colors = [variableColors.primary, variableColors.info];
  useEffect(() => {
    return () => colors;
  });

  useEffect(() => {
    AOS.init({
      startEvent: "DOMContentLoaded",
      disable: function () {
        var maxWidth = 996;
        return window.innerWidth < maxWidth;
      },
      throttleDelay: 10,
      once: true,
      duration: 700,
      offset: 10,
    });
  });

  // chart pbumku perizinan
  const chartPerizinan = {
    options: {
      chart: {
        fontFamily:
          '"Inter", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
        toolbar: {
          show: false,
        },
        sparkline: {
          enabled: false,
        },
      },
      colors: colors,
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
        width: 3,
      },
      yaxis: {
        show: true,
        labels: {
          show: true,
          minWidth: 19,
          maxWidth: 19,
          style: {
            colors: "#8A92A6",
          },
          offsetX: -5,
        },
      },
      legend: {
        show: false,
      },
      xaxis: {
        labels: {
          minHeight: 22,
          maxHeight: 22,
          show: true,
          style: {
            colors: "#8A92A6",
          },
        },
        lines: {
          show: false, //or just here to disable only x axis grids
        },
        // categories: ["CBIB", "CDOIB", "CPIB", "CPIB-K", "CPOIB", "CPPIB"],
        categories: perizinans.map(item => item?.ur_izin_singkat),
        // categories: (perizinans || []).map(item => item?.ur_izin_singkat || ""),
      },
      grid: {
        show: false,
      },
      fill: {
        type: "gradient",
        gradient: {
          shade: "dark",
          type: "vertical",
          shadeIntensity: 0,
          gradientToColors: undefined, // optional, if not defined - uses the shades of same color in series
          inverseColors: true,
          opacityFrom: 0.4,
          opacityTo: 0.1,
          stops: [0, 50, 80],
          colors: colors,
        },
      },
      tooltip: {
        enabled: true,
      },
    },
    series: [
      {
        name: "total",
        data: perizinans.map(item => item?.Jumlah),
        // data: (perizinans || []).map(item => item?.JUMLAH || 0),
      },
    ],
  };

  // chart pbumku provinsi
  const chart4 = {
    options: {
      chart: {
        fontFamily:
          '"Inter", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
        toolbar: {
          show: false,
        },
        sparkline: {
          enabled: false,
        },
        type: 'bar',
        height: 380
      },
      plotOptions: {
        bar: {
          horizontal: true,
          barHeight: '80%',
          distributed: true,
          horizontal: true,
          dataLabels: {
            position: 'bottom'
          },
        }
      },
      colors: colors,
      dataLabels: {
        enabled: true,
        textAnchor: 'end',
        style: {
          // colors: ['#fff']
          colors: ['#3D3BF3']
        },
        formatter: function (val, opt) {
          // return opt.w.globals.labels[opt.dataPointIndex] + ":  " + val
          return opt.w.globals.labels[opt.dataPointIndex]
        },
        offsetX: -30,
        dropShadow: {
          enabled: false
        }
      },
      stroke: {
        curve: "smooth",
        width: 2,
      },
      yaxis: {
        show: false,
        labels: {
          show: true,
          minWidth: 19,
          maxWidth: 19,
          style: {
            colors: "#8A92A6",
          },
          offsetX: -5,
        },
      },
      legend: {
        show: false,
      },
      xaxis: {
        labels: {
          minHeight: 22,
          maxHeight: 22,
          show: true,
          style: {
            colors: "#8A92A6",
          },
        },
        lines: {
          show: false, //or just here to disable only x axis grids
        },
        categories: provinsi.map(item => item?.URAIAN_PROPINSI),
      },
      grid: {
        show: false,
        padding: {
          left: 170, // or whatever value that works
          right: 20 // or whatever value that works
        },
      },
      fill: {
        type: "gradient",
        gradient: {
          shade: "dark",
          type: "vertical",
          shadeIntensity: 0,
          gradientToColors: undefined, // optional, if not defined - uses the shades of same color in series
          inverseColors: true,
          opacityFrom: 0.4,
          opacityTo: 0.1,
          stops: [0, 50, 80],
          colors: colors,
        },
      },
      tooltip: {
        enabled: true,
      },
    },
    series: [
      {
        name: "total",
        data: provinsi.map(item => item?.Jumlah),
      },
    ],
  };

  //chart2
  const chart2 = {
    options: {
      colors: colors,
      plotOptions: {
        radialBar: {
          hollow: {
            margin: 10,
            size: "50%",
          },
          track: {
            margin: 10,
            strokeWidth: "50%",
          },
          dataLabels: {
            show: false,
          },
        },
      },
      labels: ["Apples", "Oranges"],
    },
    series: [55, 75],
  };

  const chart3 = {
    options: {
      chart: {
        stacked: true,
        toolbar: {
          show: false,
        },
      },
      colors: colors,
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "28%",
          endingShape: "rounded",
          borderRadius: 5,
        },
      },
      legend: {
        show: false,
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        categories: frequensi.map(item => item?.TANGGAL),
        labels: {
          minHeight: 20,
          maxHeight: 20,
          style: {
            colors: "#8A92A6",
          },
        },
      },
      yaxis: {
        title: {
          text: "",
        },
        labels: {
          minWidth: 19,
          maxWidth: 19,
          style: {
            colors: "#8A92A6",
          },
        },
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return (val / 1000).toLocaleString('id-ID', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Ton";
          },
        },
      },
    },
    series: [
      {
        name: "Volume",
        data: frequensi.map(item => item?.NETTO),
      },
    ],
  };

  //chart frequensi
  const chartFrequensi = {
    options: {
      chart: {
        fontFamily:
          '"Inter", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
        toolbar: {
          show: false,
        },
        sparkline: {
          enabled: false,
        },
      },
      colors: colors,
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
        width: 3,
      },
      yaxis: {
        show: true,
        labels: {
          show: true,
          minWidth: 19,
          maxWidth: 19,
          style: {
            colors: "#8A92A6",
          },
          offsetX: -5,
        },
      },
      legend: {
        show: false,
      },
      xaxis: {
        labels: {
          minHeight: 22,
          maxHeight: 22,
          show: true,
          style: {
            colors: "#8A92A6",
          },
        },
        lines: {
          show: false, //or just here to disable only x axis grids
        },
        categories: frequensi.map(item => item?.TANGGAL),
      },
      grid: {
        show: false,
      },
      fill: {
        type: "gradient",
        gradient: {
          shade: "dark",
          type: "vertical",
          shadeIntensity: 0,
          gradientToColors: undefined, // optional, if not defined - uses the shades of same color in series
          inverseColors: true,
          opacityFrom: 0.4,
          opacityTo: 0.1,
          stops: [0, 50, 80],
          colors: colors,
        },
      },
      tooltip: {
        enabled: true,
      },
    },
    series: [
      {
        name: "Jumlah",
        data: frequensi.map(item => item?.JUMLAH),
      },
    ],
  };

  const handleSelect = (value) => {
    setSelectedBulan(value);
    // Map nama bulan Indonesia ke angka (0-11)
    const bulanMap = {
      Januari: 0,
      Februari: 1,
      Maret: 2,
      April: 3,
      Mei: 4,
      Juni: 5,
      Juli: 6,
      Agustus: 7,
      September: 8,
      Oktober: 9,
      November: 10,
      Desember: 11,
    };

    // Pisahkan nama bulan dan tahun dari input
    const [namaBulan, tahunStr] = value.split(" ");
    const tahun = parseInt(tahunStr);
    const bulan = bulanMap[namaBulan];

    if (bulan === undefined || isNaN(tahun)) {
      return null; // input tidak valid
    }

    // Buat tanggal awal dan akhir
    setStartOfMonth(new Date(tahun, bulan, 1));
    setEndOfMonth(new Date(tahun, bulan + 1, 0)) // hari ke-0 bulan berikutnya = akhir bulan ini
  };

  return (
    <Fragment>

      {!isTrader ? (
        <Fragment>
          <Row>
            <Col md="12">
              <div className="d-flex justify-content-between flex-wrap iq-navbar-header mb-4">
                <div>
                  <h1 className="text-white">Statistik SMKHP</h1>
                  <h3 className="text-light">{isVisibleUpt ? `${namaUPT} ${selectedBulan}` : `BPPMHKP ${selectedBulan}`}</h3>
                </div>
                <div className="d-flex align-items-center">
                  <Dropdown onSelect={handleSelect}>
                    <Dropdown.Toggle
                      as={Button}
                      variant="text-gray"
                      type="button"
                      id="dropdownMenuButtonSM"
                    >
                      {selectedBulan}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {bulanTahun.map(bulanTahun => (
                        <Dropdown.Item key={bulanTahun.monthYear} eventKey={bulanTahun.monthYear}>
                          {bulanTahun.monthYear}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg="3" md="6">
              <Card>
                <Card.Body>
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="bg-info text-white rounded p-3">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7.33049 2.00049H16.6695C20.0705 2.00049 21.9905 3.92949 22.0005 7.33049V16.6705C22.0005 20.0705 20.0705 22.0005 16.6695 22.0005H7.33049C3.92949 22.0005 2.00049 20.0705 2.00049 16.6705V7.33049C2.00049 3.92949 3.92949 2.00049 7.33049 2.00049ZM12.0495 17.8605C12.4805 17.8605 12.8395 17.5405 12.8795 17.1105V6.92049C12.9195 6.61049 12.7705 6.29949 12.5005 6.13049C12.2195 5.96049 11.8795 5.96049 11.6105 6.13049C11.3395 6.29949 11.1905 6.61049 11.2195 6.92049V17.1105C11.2705 17.5405 11.6295 17.8605 12.0495 17.8605ZM16.6505 17.8605C17.0705 17.8605 17.4295 17.5405 17.4805 17.1105V13.8305C17.5095 13.5095 17.3605 13.2105 17.0895 13.0405C16.8205 12.8705 16.4805 12.8705 16.2005 13.0405C15.9295 13.2105 15.7805 13.5095 15.8205 13.8305V17.1105C15.8605 17.5405 16.2195 17.8605 16.6505 17.8605ZM8.21949 17.1105C8.17949 17.5405 7.82049 17.8605 7.38949 17.8605C6.95949 17.8605 6.59949 17.5405 6.56049 17.1105V10.2005C6.53049 9.88949 6.67949 9.58049 6.95049 9.41049C7.21949 9.24049 7.56049 9.24049 7.83049 9.41049C8.09949 9.58049 8.25049 9.88949 8.21949 10.2005V17.1105Z" />
                      </svg>
                    </div>
                    <div className="text-end">
                      Frekuensi
                      <h2 className="counter">
                        <CountUp
                          start={isNol ? jumfreq : jumfreq - 20}
                          end={jumfreq}
                          duration={3}
                          formattingFn={(val) =>
                            val.toLocaleString('id-ID')
                          }
                        />
                      </h2>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col lg="3" md="6">
              <Card>
                <Card.Body>
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="bg-warning text-white rounded p-3">
                      <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 512.000000 512.000000" preserveAspectRatio="xMidYMid meet">
                        <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="#ffffff" stroke="none">
                          <path d="M2470 4926 c-77 -29 -2426 -1189 -2445 -1207 -19 -18 -20 -35 -23 -281 -2 -189 0 -270 9 -291 20 -48 57 -57 244 -57 l165 0 0 -1421 c0 -998 3 -1426 11 -1441 27 -50 -74 -48 2142 -48 1485 0 2073 3 2096 11 65 23 61 -74 61 1484 l0 1415 149 0 c82 0 162 5 180 11 57 20 61 41 61 308 l0 241 -27 28 c-19 20 -442 230 -1288 639 -693 336 -1269 613 -1280 616 -11 3 -36 0 -55 -7z m122 -585 c32 -13 649 -545 670 -579 36 -55 12 -133 -47 -158 -51 -21 -1259 -21 -1310 0 -59 25 -83 103 -47 158 18 28 609 554 645 575 27 15 58 16 89 4z m581 -1161 l1367 0 0 -1405 0 -1405 -235 0 -235 0 0 1145 c0 866 -3 1150 -12 1170 -26 58 58 55 -1497 55 -1087 0 -1436 -3 -1456 -12 -58 -26 -55 32 -55 -1213 l0 -1145 -220 0 -220 0 0 1412 0 1411 598 -6 c328 -4 1212 -7 1965 -7z m-1169 -786 c13 -13 16 -42 16 -159 0 -137 -1 -145 -22 -159 -19 -14 -66 -16 -313 -16 -247 0 -294 2 -313 16 -21 14 -22 22 -22 159 0 117 3 146 16 159 13 14 56 16 319 16 263 0 306 -2 319 -16z m-6 -520 c21 -14 22 -22 22 -159 0 -117 -3 -146 -16 -159 -13 -14 -56 -16 -319 -16 -263 0 -306 2 -319 16 -13 13 -16 42 -16 159 0 137 1 145 22 159 19 14 66 16 313 16 247 0 294 -2 313 -16z m846 5 c32 -15 36 -32 36 -174 0 -181 32 -165 -339 -165 -275 0 -310 2 -322 17 -10 11 -15 55 -17 149 -3 131 -3 134 22 159 l25 25 285 0 c189 0 293 -4 310 -11z m-842 -536 c16 -14 18 -33 18 -159 0 -136 -1 -144 -22 -158 -19 -14 -66 -16 -313 -16 -247 0 -294 2 -313 16 -21 14 -22 22 -22 156 0 118 3 145 17 160 15 17 38 18 316 18 266 0 303 -2 319 -17z m864 -7 c13 -21 15 -49 12 -161 -3 -122 -5 -138 -22 -151 -29 -21 -603 -21 -632 0 -17 13 -19 27 -19 161 0 134 2 148 19 161 16 11 77 14 323 14 l303 0 16 -24z m848 8 c13 -13 16 -42 16 -159 0 -137 -1 -145 -22 -159 -19 -14 -66 -16 -313 -16 -247 0 -294 2 -313 16 -21 14 -22 22 -22 156 0 118 3 145 17 160 15 17 38 18 319 18 262 0 305 -2 318 -16z m-1704 -533 c5 -11 10 -79 10 -151 0 -72 -5 -140 -10 -151 -10 -18 -24 -19 -325 -19 -301 0 -315 1 -325 19 -15 28 -13 294 2 309 9 9 95 12 325 12 299 0 313 -1 323 -19z m854 -3 c13 -17 16 -51 16 -148 0 -187 33 -170 -340 -170 -373 0 -340 -17 -340 170 0 187 -33 170 340 170 308 0 309 0 324 -22z m854 10 c17 -17 17 -299 0 -316 -9 -9 -95 -12 -325 -12 -299 0 -313 1 -323 19 -5 11 -10 79 -10 151 0 72 5 140 10 151 10 18 24 19 323 19 230 0 316 -3 325 -12z" />
                        </g>
                      </svg>
                    </div>
                    <div className="text-end">
                      Volume (Ton)
                      <h2 className="counter">
                        <CountUp
                          start={(jumVol / 1000) - 20}
                          start={isNol ? jumVol : (jumVol / 1000) - 20}
                          end={jumVol / 1000}
                          duration={3}
                          formattingFn={(val) =>
                            val.toLocaleString('id-ID')
                          }
                          decimals={2}
                        />
                      </h2>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col lg="3" md="6">
              <Card>
                <Card.Body>
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="bg-success text-white rounded p-3">
                      <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 512.000000 512.000000" preserveAspectRatio="xMidYMid meet">
                        <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="#ffffff" stroke="none">
                          <path d="M54 5030 c-12 -4 -29 -19 -38 -32 -15 -20 -16 -181 -16 -1765 l0 -1742 24 -28 24 -28 223 -3 c248 -4 280 -1 309 30 20 21 20 36 20 735 l0 713 331 -2 330 -3 259 -714 c164 -453 266 -721 279 -735 21 -20 30 -21 281 -21 256 0 260 0 282 23 16 16 22 33 21 60 -1 21 -121 356 -282 785 -155 412 -281 754 -281 760 0 7 39 50 87 97 225 220 328 439 353 748 44 547 -232 938 -755 1071 -201 50 -254 54 -860 57 -326 2 -579 0 -591 -6z m1016 -500 c383 -34 572 -198 587 -510 10 -202 -51 -347 -192 -458 -149 -117 -324 -156 -680 -150 l-180 3 -3 550 c-1 303 0 556 3 563 6 15 295 17 465 2z" />
                          <path d="M3846 3819 c-118 -10 -212 -34 -320 -80 -111 -47 -190 -102 -287 -196 l-76 -74 -6 83 c-4 46 -7 106 -7 135 0 82 -4 83 -256 83 l-213 0 -20 -26 -21 -27 0 -1798 c0 -1786 0 -1799 20 -1819 19 -19 33 -20 243 -20 122 0 227 4 233 8 32 21 34 50 34 653 l0 602 43 -40 c292 -269 794 -321 1198 -124 169 83 338 226 443 375 270 382 342 998 174 1475 -135 383 -407 652 -760 755 -70 20 -284 50 -323 45 -5 -1 -50 -5 -99 -10z m244 -509 c104 -35 197 -95 290 -189 99 -100 158 -196 206 -339 42 -124 55 -209 55 -352 -2 -437 -266 -807 -625 -875 -96 -19 -152 -19 -238 0 -139 29 -253 92 -358 197 -160 159 -253 380 -267 628 -24 452 220 840 591 941 94 25 251 21 346 -11z" />
                        </g>
                      </svg>
                    </div>
                    <div className="text-end">
                      Nilai IDR
                      <h4 className="counter">
                        <CountUp
                          start={isNol ? nilaiIDR : nilaiIDR - 20}
                          end={nilaiIDR}
                          duration={3}
                          formattingFn={(val) =>
                            val.toLocaleString('id-ID')
                          }
                          decimals={2}
                        />
                      </h4>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col lg="3" md="6">
              <Card>
                <Card.Body>
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="bg-danger text-white rounded p-3">
                      <svg height="24px" fill="currentColor" viewBox="0 0 1792 1792" width="24px" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1362 1185q0 153-99.5 263.5t-258.5 136.5v175q0 14-9 23t-23 9h-135q-13 0-22.5-9.5t-9.5-22.5v-175q-66-9-127.5-31t-101.5-44.5-74-48-46.5-37.5-17.5-18q-17-21-2-41l103-135q7-10 23-12 15-2 24 9l2 2q113 99 243 125 37 8 74 8 81 0 142.5-43t61.5-122q0-28-15-53t-33.5-42-58.5-37.5-66-32-80-32.5q-39-16-61.5-25t-61.5-26.5-62.5-31-56.5-35.5-53.5-42.5-43.5-49-35.5-58-21-66.5-8.5-78q0-138 98-242t255-134v-180q0-13 9.5-22.5t22.5-9.5h135q14 0 23 9t9 23v176q57 6 110.5 23t87 33.5 63.5 37.5 39 29 15 14q17 18 5 38l-81 146q-8 15-23 16-14 3-27-7-3-3-14.5-12t-39-26.5-58.5-32-74.5-26-85.5-11.5q-95 0-155 43t-60 111q0 26 8.5 48t29.5 41.5 39.5 33 56 31 60.5 27 70 27.5q53 20 81 31.5t76 35 75.5 42.5 62 50 53 63.5 31.5 76.5 13 94z" />
                      </svg>
                    </div>
                    <div className="text-end">
                      Nilai USD
                      <h3 className="counter">
                        <CountUp
                          start={isNol ? nilaiUSD : nilaiUSD - 20}
                          end={nilaiUSD}
                          duration={3}
                          formattingFn={(val) =>
                            val.toLocaleString('id-ID')
                          }
                          decimals={2}
                        />
                      </h3>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col md="12" lg="6">
              <Row>
                <Col md="12">
                  <div className="card">
                    <div className="flex-wrap card-header d-flex justify-content-between">
                      <div className="header-title">
                        <h5 className="card-title">Frekuensi</h5>
                      </div>
                      <div className="d-flex align-items-center align-self-center">
                      </div>
                    </div>
                    <div className="card-body">
                      <Chart
                        options={chartFrequensi.options}
                        series={chartFrequensi.series}
                        type="area"
                        height="245"
                      />
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>


            <Col md="12" xl="6">
              <div className="card" data-aos="fade-up" data-aos-delay="1000">
                <div className="flex-wrap card-header d-flex justify-content-between">
                  <div className="header-title">
                    <h5 className="card-title">Volume</h5>
                  </div>
                </div>
                <div className="card-body">
                  <Chart
                    className="d-activity"
                    options={chart3.options}
                    series={chart3.series}
                    type="bar"
                    height="260"
                  />
                </div>
              </div>
            </Col>

            <Col lg="12">
              <Row>
                {frequensiNegara.map((freqnegara, index) => (
                  <Col md="3">
                    <Card>
                      <Card.Body>
                        <div className="d-flex justify-content-center align-items-between gap-2">
                          <div className="text-end">
                            <span>{freqnegara.negara_tujuan}</span>
                            <div>
                              <h6 className="counter text-end">
                                <CountUp
                                  start={freqnegara.jumlah - 20}
                                  end={freqnegara.jumlah}
                                  duration={3}
                                  formattingFn={(val) =>
                                    val.toLocaleString('id-ID')
                                  }
                                />
                                <span className="text-success"> Kali</span>
                              </h6>
                            </div>
                            <div>
                              <h6 className="counter text-end">
                                {/* <CountUp start= {(freqnegara.netto / 1000).toLocaleString('id-ID', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} end= {(freqnegara.netto / 1000).toLocaleString('id-ID', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} duration={3} />  */}
                                <CountUp
                                  start={freqnegara.netto / 1000 - 20}
                                  end={freqnegara.netto / 1000}
                                  duration={3}
                                  formattingFn={(val) =>
                                    val.toLocaleString('id-ID')
                                  } />
                                <span className="text-success"> Ton</span>
                              </h6>
                            </div>
                          </div>
                          <div>
                            <div className="d-flex">
                              <div className="bg-soft-primary text-white p-3 rounded">
                                <img
                                  src={`https://flagcdn.com/w40/${freqnegara.kode_negara_partner.toLowerCase()}.png`}
                                  alt={`Bendera ${freqnegara.negara_tujuan}`}
                                  width="40"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>
            </Col>

            {/* Frequensi Per UPT tidak muncul jika yang login pusat  */}
            {!isVisibleUpt && (
              <Col md="12" lg="6">
                <div
                  className="overflow-hidden card"
                // data-aos="fade-up"
                // data-aos-delay="600"
                >
                  <div className="flex-wrap card-header d-flex justify-content-between">
                    <div className="header-title">
                      <h5 className="mb-2 card-title">Volume/Frekuensi Per UPT</h5>
                      {/* <p className="mb-0">
                      <svg
                        className="me-2"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="#3a57e8"
                          d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"
                        />
                      </svg>
                      15 new acquired this month
                    </p> */}
                    </div>
                  </div>
                  <div className="p-0 card-body">
                    <div className="mt-4 table-responsive">
                      <table
                        id="basic-table"
                        className="table mb-0 table-striped table-hover"
                        role="grid"
                      >
                        <thead>
                          <tr>
                            <th>UPT</th>
                            <th>VOLUME (TON)</th>
                            <th>FREQUENSI</th>
                            {/* <th>PERSENTASE</th> */}
                          </tr>
                        </thead>
                        <tbody>
                          {frequensiUpt.map((frequpt, index) => (
                            <tr >
                              <td>{index + 1} {". "} {frequpt.nama_upt}</td>
                              {/* <div className="d-flex align-items-center">
                            <h6>{index + 1} {". "} {frequpt.nama_upt}</h6>
                          </div>
                        </td> */}
                              <td className="text-end">{(frequpt.netto / 1000).toLocaleString('id-ID', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                              <td className="text-end">{frequpt.jumlah.toLocaleString('id-ID')}</td>
                              {/* <td>
                          <div className="mb-2 d-flex align-items-center">
                            <h6>{((frequpt.jumlah / jumfreq) * 100).toFixed(2)}{"%"}</h6>
                          </div>
                          <Progress
                            softcolors="primary"
                            color="primary"
                            className="shadow-none w-100"
                            value={(frequpt.jumlah / jumfreq) * 100}
                            minvalue={0}
                            maxvalue={100}
                            style={{ height: "4px" }}
                          />
                        </td> */}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </Col>
            )}

            <Col md="12" lg="6">
              <div
                className="overflow-hidden card"
              // data-aos="fade-up"
              // data-aos-delay="600"
              >
                <div className="flex-wrap card-header d-flex justify-content-between">
                  <div className="header-title">
                    <h5 className="mb-2 card-title">Volume/Frekuensi Per Trader</h5>
                    {/* <p className="mb-0">
                      <svg
                        className="me-2"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="#3a57e8"
                          d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"
                        />
                      </svg>
                      15 new acquired this month
                    </p> */}
                  </div>
                </div>
                <div className="p-0 card-body">
                  <div className="mt-4 table-responsive">
                    <table
                      id="basic-table"
                      className="table mb-0 table-striped table-hover"
                      role="grid"
                    >
                      <thead>
                        <tr>
                          <th>TRADER</th>
                          <th>VOLUME (TON)</th>
                          <th>FREQUENSI</th>
                          {/* <th>PERSENTASE</th> */}
                        </tr>
                      </thead>
                      <tbody>
                        {frequensiTrader.map((freqtrd, index) => (
                          <tr >
                            <td>{index + 1} {". "} {freqtrd.nama_trader}</td>
                            {/* <div className="d-flex align-items-center">
                            <h6>{index + 1} {". "} {frequpt.nama_upt}</h6>
                          </div>
                        </td> */}
                            <td className="text-end">{(freqtrd.netto / 1000).toLocaleString('id-ID', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                            <td className="text-end">{freqtrd.jumlah.toLocaleString('id-ID')}</td>
                            {/* <td>
                          <div className="mb-2 d-flex align-items-center">
                            <h6>{((freqtrd.jumlah / jumfreq) * 100).toFixed(2)}{"%"}</h6>
                          </div>
                          <Progress
                            softcolors="primary"
                            color="primary"
                            className="shadow-none w-100"
                            value={(freqtrd.jumlah / jumfreq) * 100}
                            minvalue={0}
                            maxvalue={100}
                            style={{ height: "4px" }}
                          />
                        </td> */}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </Col>

            {/* <Col md="12" lg="4">
          <Row>
            <div
              className="overflow-hidden card"
            >
              <div className="p-0 card-body">
                <div className="mt-4 table-responsive">
                  <table
                    id="basic-table"
                    className="table mb-0 table-striped"
                    role="grid"
                  >
                    <tbody className="table-border-bottom-0 bg-soft-primary">
                      {frequensiNegara.map((freqnegara, index) => (
                        <tr >
                          <td>
                            <img
                              src={`https://flagcdn.com/w40/${freqnegara.kode_negara_partner.toLowerCase()}.png`}
                              alt={`Bendera ${freqnegara.negara_tujuan}`}
                              width="40"
                            />
                          </td>
                          <td className="text-end">{freqnegara.jumlah}</td>
                          <td className="text-end"> {(freqnegara.netto / 1000).toLocaleString('id-ID', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} TON</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </Row>
        </Col> */}

          </Row>
        </Fragment>
      ) : (
        <Fragment>
        <Row>
          <Col md="12">
            <div className="d-flex justify-content-between flex-wrap iq-navbar-header mb-4">
              <div>
                <h1 className="text-white">Sistem Informasi Aplikasi Pelayanan Mutu</h1>
                <h3 className="text-light">BPPMHKP</h3>
              </div>
            </div>
          </Col>
        </Row>
        </Fragment>
      )}


      {/* <Row>
        <Col md="12" lg="12">
          <Row className="row-cols-1">
            <div
              className="overflow-hidden d-slider1 "
              data-aos="fade-up"
              data-aos-delay="800"
            >
              <Swiper
                className="p-0 m-0 mb-2 list-inline "
                slidesPerView={5}
                spaceBetween={32}
                navigation={{
                  nextEl: ".swiper-button-next",
                  prevEl: ".swiper-button-prev",
                }}
                breakpoints={{
                  320: { slidesPerView: 1 },
                  550: { slidesPerView: 2 },
                  991: { slidesPerView: 3 },
                  1400: { slidesPerView: 3 },
                  1500: { slidesPerView: 4 },
                  1920: { slidesPerView: 4 },
                  2040: { slidesPerView: 7 },
                  2440: { slidesPerView: 8 },
                }}
              >
                <SwiperSlide className="card card-slide">
                  <div className="card-body">
                    <div className="progress-widget">
                      <Circularprogressbar
                        stroke={variableColors.primary}
                        width="60px"
                        height="60px"
                        Linecap="rounded"
                        trailstroke="#ddd"
                        strokewidth="4px"
                        style={{ width: 60, height: 60 }}
                        value={90}
                        id="circle-progress-01"
                      >
                        <svg
                          className=""
                          width="24"
                          height="24px"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="currentColor"
                            d="M5,17.59L15.59,7H9V5H19V15H17V8.41L6.41,19L5,17.59Z"
                          />
                        </svg>
                      </Circularprogressbar>
                      <div className="progress-detail">
                        <p className="mb-2">Total Permohonan</p>
                        <h4 className="counter">
                          <CountUp
                            start={permohonanCnt - 15}
                            end={permohonanCnt}
                            duration={3}
                          />
                        </h4>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide className=" card card-slide">
                  <div className="card-body">
                    <div className="progress-widget">
                      <Circularprogressbar
                        stroke={variableColors.info}
                        width="60px"
                        height="60px"
                        trailstroke="#ddd"
                        strokewidth="4px"
                        Linecap="rounded"
                        style={{ width: 60, height: 60 }}
                        value={60}
                        id="circle-progress-02"
                      >
                        <svg
                          className=""
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="currentColor"
                            d="M19,6.41L17.59,5L7,15.59V9H5V19H15V17H8.41L19,6.41Z"
                          />
                        </svg>
                      </Circularprogressbar>
                      <div className="progress-detail">
                        <p className="mb-2">Sertifikat Terbit</p>
                        <h4 className="counter">
                          <CountUp
                            start={20}
                            end={sertifikatCnt}
                            duration={3}
                          />
                        </h4>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide className=" card card-slide">
                  <div className="card-body">
                    <div className="progress-widget">
                      <Circularprogressbar
                        stroke={variableColors.primary}
                        width="60px"
                        height="60px"
                        trailstroke="#ddd"
                        strokewidth="4px"
                        Linecap="rounded"
                        style={{ width: 60, height: 60 }}
                        value={70}
                        id="circle-progress-03"
                      >
                        <svg className="" width="24" viewBox="0 0 24 24">
                          <path
                            fill="currentColor"
                            d="M19,6.41L17.59,5L7,15.59V9H5V19H15V17H8.41L19,6.41Z"
                          />
                        </svg>
                      </Circularprogressbar>
                      <div className="progress-detail">
                        <p className="mb-2">Verifikasi</p>
                        <h4 className="counter">
                          <CountUp start={20} end={verifyCnt} duration={3} />
                        </h4>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide className=" card card-slide">
                  <div className="card-body">
                    <div className="progress-widget">
                      <Circularprogressbar
                        stroke={variableColors.info}
                        width="60px"
                        height="60px"
                        trailstroke="#ddd"
                        strokewidth="4px"
                        Linecap="rounded"
                        style={{ width: 60, height: 60 }}
                        value={60}
                        id="circle-progress-04"
                      >
                        <svg
                          className=""
                          width="24px"
                          height="24px"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="currentColor"
                            d="M5,17.59L15.59,7H9V5H19V15H17V8.41L6.41,19L5,17.59Z"
                          />
                        </svg>
                      </Circularprogressbar>
                      <div className="progress-detail">
                        <p className="mb-2">Total SPT Terbit</p>
                        <h4 className="counter">
                          <CountUp start={0} end={spt} duration={3} />
                        </h4>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <div className="swiper-button swiper-button-next"></div>
                <div className="swiper-button swiper-button-prev"></div>
              </Swiper>
            </div>
          </Row>
        </Col>
        <Col md="6" lg="6">
          <Card className="bg-soft-primary mt-4">
            <Card.Body>
              <div className="d-flex flex-column">
                <div className="mb-3">
                  <h2>Rekapitulasi Permohonan</h2>
                  <span className="text-primary">Per Perizinan</span>
                </div>
                <div className="border rounded bg-soft-primary">
                  <Chart options={chartPerizinan.options} series={chartPerizinan.series} type="bar" height="250" />
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col md="6" lg="6">
          <Card className="bg-soft-primary mt-4">
            <Card.Body>
              <div className="d-flex flex-column">
                <div className="mb-3">
                  <h2>Rekapitulasi Permohonan</h2>
                  <span className="text-primary">Per Provinsi</span>
                </div>
                <div className="border rounded bg-soft-primary">
                  <Chart options={chart4.options} series={chart4.series} type="bar" height="250" />
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col md="12" lg="12">
          <Card className="bg-soft-primary mt-1">
            <Card.Body>
              <div className="d-flex flex-column">
                <div className="mb-3">
                  <h2>Sertifikasi HACCP</h2>
                  <span className="text-primary">2025</span>
                </div>
                <div className="border rounded">
                  <Row>
                    <Col lg="3" md="6" className="col-lg-3 col-md-6">
                      <Card className="bg-soft-info">
                        <Card.Body>
                          <div className="d-flex justify-content-between align-items-center">
                            <div className="bg-soft-info rounded p-3">
                              <svg xmlns="http://www.w3.org/2000/svg" width="22px" height="22px" viewBox="0 0 22 22" fill="currentColor">
                                <path fillRule="evenodd" d="M9.13478 20.7733V17.7156C9.13478 16.9351 9.77217 16.3023 10.5584 16.3023H13.4326C13.8102 16.3023 14.1723 16.4512 14.4393 16.7163C14.7063 16.9813 14.8563 17.3408 14.8563 17.7156V20.7733C14.8539 21.0978 14.9821 21.4099 15.2124 21.6402C15.4427 21.8705 15.7561 22 16.0829 22H18.0438C18.9596 22.0023 19.8388 21.6428 20.4872 21.0008C21.1356 20.3588 21.5 19.487 21.5 18.5778V9.86686C21.5 9.13246 21.1721 8.43584 20.6046 7.96467L13.934 2.67587C12.7737 1.74856 11.1111 1.7785 9.98539 2.74698L3.46701 7.96467C2.87274 8.42195 2.51755 9.12064 2.5 9.86686V18.5689C2.5 20.4639 4.04738 22 5.95617 22H7.87229C8.55123 22 9.103 21.4562 9.10792 20.7822L9.13478 20.7733Z" clipRule="evenodd" />
                              </svg>
                            </div>
                            <div className="text-end">
                              <h2 className="counter"><CountUp start={upi - 50} end={upi} duration={3} /></h2>
                              UPI Tersertifikasi
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col lg="3" md="6">
                      <Card className="bg-soft-warning">
                        <Card.Body>
                          <div className="d-flex justify-content-between align-items-center">
                            <div className="bg-soft-warning rounded p-3">
                              <svg xmlns="http://www.w3.org/2000/svg" width="22px" height="22px" viewBox="0 0 22 22" fill="currentColor">
                                <path fillRule="evenodd" d="M7.81 2H16.191C19.28 2 21 3.78 21 6.83V17.16C21 20.26 19.28 22 16.191 22H7.81C4.77 22 3 20.26 3 17.16V6.83C3 3.78 4.77 2 7.81 2ZM8.08 6.66V6.65H11.069C11.5 6.65 11.85 7 11.85 7.429C11.85 7.87 11.5 8.22 11.069 8.22H8.08C7.649 8.22 7.3 7.87 7.3 7.44C7.3 7.01 7.649 6.66 8.08 6.66ZM8.08 12.74H15.92C16.35 12.74 16.7 12.39 16.7 11.96C16.7 11.53 16.35 11.179 15.92 11.179H8.08C7.649 11.179 7.3 11.53 7.3 11.96C7.3 12.39 7.649 12.74 8.08 12.74ZM8.08 17.31H15.92C16.319 17.27 16.62 16.929 16.62 16.53C16.62 16.12 16.319 15.78 15.92 15.74H8.08C7.78 15.71 7.49 15.85 7.33 16.11C7.17 16.36 7.17 16.69 7.33 16.95C7.49 17.2 7.78 17.35 8.08 17.31Z" clipRule="evenodd" />
                              </svg>
                            </div>
                            <div className="text-end">
                              <h2 className="counter"><CountUp start={haccp - 50} end={haccp} duration={3} /></h2>
                              Sertifikasi HACCP
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col lg="3" md="6">
                      <Card className="bg-soft-danger">
                        <Card.Body>
                          <div className="d-flex justify-content-between align-items-center">
                            <div className="bg-soft-danger rounded p-3">
                              <svg xmlns="http://www.w3.org/2000/svg" width="22px" height="22px" viewBox="0 0 22 22" fill="currentColor">
                                <path d="M8.92574 16.39H14.3119C14.7178 16.39 15.0545 16.05 15.0545 15.64C15.0545 15.23 14.7178 14.9 14.3119 14.9H8.92574C8.5198 14.9 8.18317 15.23 8.18317 15.64C8.18317 16.05 8.5198 16.39 8.92574 16.39ZM12.2723 9.9H8.92574C8.5198 9.9 8.18317 10.24 8.18317 10.65C8.18317 11.06 8.5198 11.39 8.92574 11.39H12.2723C12.6782 11.39 13.0149 11.06 13.0149 10.65C13.0149 10.24 12.6782 9.9 12.2723 9.9ZM19.3381 9.02561C19.5708 9.02292 19.8242 9.02 20.0545 9.02C20.302 9.02 20.5 9.22 20.5 9.47V17.51C20.5 19.99 18.5099 22 16.0545 22H8.17327C5.59901 22 3.5 19.89 3.5 17.29V6.51C3.5 4.03 5.5 2 7.96535 2H13.2525C13.5099 2 13.7079 2.21 13.7079 2.46V5.68C13.7079 7.51 15.203 9.01 17.0149 9.02C17.4381 9.02 17.8112 9.02316 18.1377 9.02593C18.3917 9.02809 18.6175 9.03 18.8168 9.03C18.9578 9.03 19.1405 9.02789 19.3381 9.02561ZM19.6111 7.566C18.7972 7.569 17.8378 7.566 17.1477 7.559C16.0527 7.559 15.1507 6.648 15.1507 5.542V2.906C15.1507 2.475 15.6685 2.261 15.9646 2.572C16.5004 3.13476 17.2368 3.90834 17.9699 4.67837C18.7009 5.44632 19.4286 6.21074 19.9507 6.759C20.2398 7.062 20.0279 7.565 19.6111 7.566Z" />
                              </svg>
                            </div>
                            <div className="text-end">
                              <h2 className="counter"><CountUp start={skv - 50} end={skv} duration={3} /></h2>
                              SKHS
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col lg="3" md="6">
                      <Card className="bg-soft-primary">
                        <Card.Body>
                          <div className="d-flex justify-content-between align-items-center">
                            <div className="bg-soft-primary rounded p-3">
                              <svg xmlns="http://www.w3.org/2000/svg" width="22px" height="22px" viewBox="0 0 22 22" fill="currentColor">
                                <path fillRule="evenodd" d="M9.5 12.5537C12.2546 12.5537 14.4626 10.3171 14.4626 7.52684C14.4626 4.73663 12.2546 2.5 9.5 2.5C6.74543 2.5 4.53737 4.73663 4.53737 7.52684C4.53737 10.3171 6.74543 12.5537 9.5 12.5537ZM9.5 15.0152C5.45422 15.0152 2 15.6621 2 18.2464C2 20.8298 5.4332 21.5 9.5 21.5C13.5448 21.5 17 20.8531 17 18.2687C17 15.6844 13.5668 15.0152 9.5 15.0152ZM19.8979 9.58786H21.101C21.5962 9.58786 22 9.99731 22 10.4995C22 11.0016 21.5962 11.4111 21.101 11.4111H19.8979V12.5884C19.8979 13.0906 19.4952 13.5 18.999 13.5C18.5038 13.5 18.1 13.0906 18.1 12.5884V11.4111H16.899C16.4027 11.4111 16 11.0016 16 10.4995C16 9.99731 16.4027 9.58786 16.899 9.58786H18.1V8.41162C18.1 7.90945 18.5038 7.5 18.999 7.5C19.4952 7.5 19.8979 7.90945 19.8979 8.41162V9.58786Z" clipRule="evenodd" />
                              </svg>
                            </div>
                            <div className="text-end">
                              <h2 className="counter"><CountUp start={upn - 50} end={upn} duration={3} /></h2>
                              UPI Baru
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row> */}



    </Fragment>
  );
});

export default Index;
